import react from "react";
import Request from "../../../../api/Requests";
import axios from 'axios';

const getInfoEventTables = (params) => {
    return Request('events/info-event-tables', 'GET', params, true);
}

const getInfoActionTable = (params) => {
    return Request('events/info-action-table', 'GET', params, true);
}


const reserveEventTable = (params) => {
    return Request('events/reserve-event-table', 'POST', params, true);
}


const checkOutTable = (params) => {
    return Request('events/checkout-event-table', 'POST', params, true);
}


const cancelTable = (params) => {
    return Request('events/cancel-event-table', 'POST', params, true);
}


const getListReservationsEvent = (params) => {
    return Request('events/list-reservations-event-tables', 'GET', params, true);
}

const getListTransactionsEvent = (params) => {
    return Request('events/list-transactions-event-tables', 'GET', params, true);
}


const checkClientExist = (params) => {
    return Request('events/event-tables-check-client-exist', 'POST', params, true);
}




export default {
    getInfoEventTables,
    getInfoActionTable,
    reserveEventTable,
    checkOutTable,
    cancelTable,
    getListReservationsEvent,
    getListTransactionsEvent,
    checkClientExist
}